export function GetTopUpMethods() {
  return [
    {
      key: 0,
      description: "Manual"
    },
    {
      key: 1,
      description: "Credit Card"
    },
    {
      key: 2,
      description: "Grab Pay"
    },
    {
      key: 2003,
      description: "Alipay"
    },
    {
      key: 2004,
      description: "Wechat Pay"
    },
    {
      key: 2005,
      description: "Pay Now"
    },
    {
      key: 3001,
      description: "Gopay"
    },
    {
      key: 3002,
      description: "Bank Transfer"
    },
    {
      key: 3023,
      description: "QRIS"
    }
  ];
}

export function GetSGDTopUpMethods() {
  return [
    {
      key: 0,
      description: "Manual"
    },
    {
      key: 1,
      description: "Credit Card"
    },
    {
      key: 2,
      description: "Grab Pay"
    },
    {
      key: 2003,
      description: "Alipay"
    },
    {
      key: 2004,
      description: "Wechat Pay"
    },
    {
      key: 2005,
      description: "Pay Now"
    }
  ];
}

export function GetIDRTopUpMethods() {
  return [
    {
      key: 0,
      description: "Manual"
    },
    {
      key: 3001,
      description: "Gopay"
    },
    {
      key: 3002,
      description: "Bank Transfer"
    },
    {
      key: 3023,
      description: "QRIS"
    }
  ];
}

export function GetTopUpMethodDescription(value) {
  let topUpMethod = GetTopUpMethods().find(item => item.key === value);
  return topUpMethod ? topUpMethod.description : "Unknown";
}
